module.exports = __webpack_public_path__ + "media/task_complete.65cbc60e.wav";